/** Generated versions in a stable order: oldest run first, then Version 1, 2 inside each run. */
export function sortedGenerated(versions) {
  const gen = (versions || []).filter((v) => v.kind === "generated");
  const runStart = {};
  gen.forEach((v) => {
    const k = v.run_id || v.id;
    if (!runStart[k] || String(v.created_at) < runStart[k]) runStart[k] = String(v.created_at);
  });
  return gen.sort((a, b) => runStart[a.run_id || a.id].localeCompare(runStart[b.run_id || b.id]) || (a.take || 0) - (b.take || 0));
}

/** Pick which generated version to work on (sing over / replace the lead of). */
export default function VersionPills({ versions, current, onPick, label, testId = "version-picker", tone = "rose" }) {
  if (versions.length < 2) return null;
  const on = tone === "rose" ? "border-rose-300/60 bg-rose-500/15 text-white" : "border-amber-300/60 bg-amber-500/15 text-white";
  return (
    <div data-testid={testId} className="mb-8 flex flex-wrap items-center gap-2">
      <span className="mr-1 font-mono text-[10px] uppercase tracking-[0.16em] text-white/50">{label}</span>
      {versions.map((v) => (
        <button key={v.id} type="button" data-testid={`${testId}-${v.id}`} aria-pressed={v.id === current.id} onClick={() => onPick(v.id)}
          className={`rounded-full border px-3 py-1.5 font-mono text-[10px] uppercase tracking-wider transition-colors duration-200 ${v.id === current.id ? on : "border-white/10 text-white/55 hover:text-white"}`}>
          Version {v.take} · {new Date(v.created_at).toLocaleDateString()}
        </button>
      ))}
    </div>
  );
}
